import { ColDef } from 'ag-grid-community';
import { ColumnTooltip } from '../../../components/TachoTooltip/columnTooltip';
import { Distributor } from '../../../../core/domainModels/distributors/Distributor';
import { assignColDefsDefaults, COLUMN_WIDTH, fieldName } from '../../../../core/helpers/aggrid';
import { TachoColumnState } from '../../../../core/domainModels/displayPreferences/tachoColumnState';

export const distributorsTableDefaultColumnsDefs: ColDef = {
    sortable: true,
    resizable: true,
    tooltipComponent: ColumnTooltip,
    sortingOrder: ['asc', 'desc'],
};

export const distributorsTableColumnsDefinitions = (
    formatMessage: ({ id }: { id: string }) => string,
    defColumnState: Array<TachoColumnState>,
): Array<ColDef> => {
    const columns: Array<ColDef> = [
        {
            colId: fieldName<Distributor>('name'),
            headerName: formatMessage({ id: 'distributorName' }),
            headerTooltip: formatMessage({ id: 'distributorName' }),
            field: fieldName<Distributor>('name'),
            initialWidth: COLUMN_WIDTH.XL,
        },
        {
            colId: fieldName<Distributor>('email'),
            headerName: formatMessage({ id: 'distributorEmail' }),
            headerTooltip: formatMessage({ id: 'distributorEmail' }),
            field: fieldName<Distributor>('email'),
            initialWidth: COLUMN_WIDTH.XL,
        },
        {
            colId: fieldName<Distributor>('notes'),
            headerName: formatMessage({ id: 'distributorNotes' }),
            headerTooltip: formatMessage({ id: 'distributorNotes' }),
            field: fieldName<Distributor>('notes'),
            initialWidth: COLUMN_WIDTH.MD,
        },
    ];
    assignColDefsDefaults(columns, defColumnState, true);
    return columns;
};
